var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopStep1213(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 16,
    viewBox: "0 0 31 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7032 8.70711C31.0937 8.31658 31.0937 7.68342 30.7032 7.29289L24.3392 0.928933C23.9487 0.538408 23.3155 0.538408 22.925 0.928933C22.5345 1.31946 22.5345 1.95262 22.925 2.34315L28.5819 8L22.925 13.6569C22.5345 14.0474 22.5345 14.6805 22.925 15.0711C23.3156 15.4616 23.9487 15.4616 24.3392 15.0711L30.7032 8.70711ZM-0.00390616 9L29.9961 9L29.9961 7L-0.00390634 7L-0.00390616 9Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopStep1213);
export default __webpack_public_path__ + "static/media/laptop_step_12_13.48cd34cafb0780f7a948b187ae98438e.svg";
export { ForwardRef as ReactComponent };